<template>
    <footer class="footer">
        <BContainer fluid>
            <BRow>
                <BCol col sm="6">
                    {{ new Date().getFullYear() }} © SBG
                    <span v-if="version" class="ms-2">v{{ version }}</span>
                </BCol>
                <BCol col sm="6">
                    <div class="text-sm-end d-none d-sm-block">
                        Design & Develop by Dynamic Development Studio
                    </div>
                </BCol>
            </BRow>
        </BContainer>
    </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const version = ref('');

onMounted(async () => {
    try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (res.ok) {
            const data = await res.json();
            version.value = data.version;
        }
    } catch (e) {
        console.warn('[footer] Could not load version', e);
    }
});
</script>
